import superagent from '@ott/superagent';
import { useSelector } from 'react-redux';
import { defaultSelectAuth, FirstLikeModalProps } from '../blocks/FirstLikeModal/FirstLikeModal';
import { useEffect, useState } from 'react';

export type ObserverParams = Pick<FirstLikeModalProps, 'selectAuth'>;

/**
 * Позволяем пользователю налайкать экскурсии, даже если он не авторизован.
 * Если же он авторизуется, то мы должны смерджить эти лайки с лайками в его профиле,
 * поэтому на бэк мы отправляем предыдущий вид. Текущий вид бэк берет из хэдеров запроса.
 * */
const useLikesMergeObserver = ({ selectAuth = defaultSelectAuth }: ObserverParams) => {
  const [nonAuthorizedUserVid, setNonAuthorizedUserVid] = useState(null);
  const { auth: isAuthorized, vid } = useSelector(selectAuth) || {};

  useEffect(() => {
    if (!isAuthorized && vid) {
      setNonAuthorizedUserVid(vid);
    }
  }, [isAuthorized, vid]);

  useEffect(() => {
    if (isAuthorized && nonAuthorizedUserVid) {
      superagent
        .post(`/_activities/v3/favorites/move/${nonAuthorizedUserVid}`)
        .then(() => setNonAuthorizedUserVid(null));
    }
  }, [isAuthorized, nonAuthorizedUserVid]);
};

export default useLikesMergeObserver;
